{
    "weekDaysSelector": {
        "0": "SU",
        "1": "MO",
        "2": "TU",
        "3": "WE",
        "4": "TH",
        "5": "FR",
        "6": "SA"
    },
    "sessionsForm": {
        "template": "Enclosure capacity",
        "capacity": "Abonoteatro capacity",
        "ticket": "Event ticket",
        "soldTickets": "Sold tickets",
        "ticketSubscription": "Subscriber ticket",
        "accompanyingTicketPrice": "Accompanying ticket",
        "subscriberCosts": "Subscriber costs",
        "accompanyingCosts": "Accompanying costs"
    },
    "eventSessionFinishSelector": {
        "sessionFinishByAction": "Session close by action",
        "sessionFinishAt": "Session close by time"
    }
}
